var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#DE4242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6783L11.5129 10.1917C11.3894 10.0683 11.2246 10.0002 11.0488 10C10.873 10 10.708 10.0681 10.5847 10.1917L10.1916 10.5849C10.0678 10.7085 10 10.8733 10 11.0492C10 11.2248 10.0678 11.3896 10.1916 11.5132L14.6785 15.9998L10.1916 20.4866C10.0678 20.61 10 20.7749 10 20.9507C10 21.1263 10.0678 21.2912 10.1916 21.4146L10.5847 21.808C10.8407 22.064 11.2572 22.064 11.5129 21.808L16 17.3213L20.4869 21.808C20.6106 21.9315 20.7754 21.9995 20.9512 21.9995C21.1269 21.9995 21.2917 21.9315 21.4153 21.808L21.8084 21.4147C21.9321 21.2913 22 21.1263 22 20.9508C22 20.775 21.9321 20.6101 21.8084 20.4867L17.3215 15.9999L21.8084 11.5133C21.9321 11.3897 22 11.2249 22 11.0493L22 11.0491C22 10.8734 21.9321 10.7086 21.8084 10.585L21.4153 10.1918C21.2918 10.0684 21.1269 10.0003 20.9512 10.0003C20.7754 10.0003 20.6106 10.0684 20.487 10.1918L16 14.6783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossButton);
export default __webpack_public_path__ + "static/media/icon-cross-button.bbabf59d90f27e631e35bdc7b2f21eea.svg";
export { ForwardRef as ReactComponent };